/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const NotesIconOutline = createIcon({
  displayName: 'NotesIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <Box
          as="path"
          d="M14,21h-8c-1.105,0 -2,-0.895 -2,-2v-10c0,-1.105 0.895,-2 2,-2h8c1.105,0 2,0.895 2,2v10c0,1.105 -0.895,2 -2,2Z"
        ></Box>
        <Box
          as="path"
          d="M16,17h2c1.105,0 2,-0.895 2,-2v-10c0,-1.105 -0.895,-2 -2,-2h-8c-1.105,0 -2,0.895 -2,2v2"
        ></Box>
        <Box as="path" d="M8,12h4"></Box>
        <Box as="path" d="M8,16h4"></Box>
      </Box>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const NotesIconTwoTone = createIcon({
  displayName: 'NotesIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="twoToneStrokeColor"
        fill="twoToneFillColor"
        strokeLinejoin="round"
      >
        <Box
          as="path"
          fill="twoToneLightColor"
          d="M16,17h2c1.105,0 2,-0.895 2,-2v-10c0,-1.105 -0.895,-2 -2,-2h-8c-1.105,0 -2,0.895 -2,2v2"
        ></Box>
        <Box
          as="path"
          d="M14,21h-8c-1.105,0 -2,-0.895 -2,-2v-10c0,-1.105 0.895,-2 2,-2h8c1.105,0 2,0.895 2,2v10c0,1.105 -0.895,2 -2,2Z"
        ></Box>
        <Box as="path" d="M8,12h4"></Box>
        <Box as="path" d="M8,16h4"></Box>
      </Box>
      <Box as="path" fill="none" d="M0,0h24v24h-24Z"></Box>
    </>
  ),
})

const HeadNotess: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={NotesIconTwoTone} {...props} />
    default:
      return <CustomIcon as={NotesIconOutline} {...props} />
  }
}

export default memo(HeadNotess)
